import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import './bidding.css';
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import jwt from 'jwt-decode';
import { allowedFileTypes, FILE_NAME_VALIDATION_ERROR, PROD } from "../../../common/constants";
import { authKey, DOWNLOAD_DOCUMENT, GET_BIDDING_DETAILS, ADD_BIDDING_DETAILS, GET_STAKEHOLDER_CATEGORY, ACCEPT_BID_DOCUMENT, GET_BIDDINGS_LIST_BY_REQ_NUMBER, UPLOAD_DCUMENT } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";
import Link from "@mui/material/Link";
import moment from 'moment';
import { toast } from 'react-toastify';
import { fileNameValidation, PIT_VALIDATIONS } from "../../../common/commonValidations";
import { Button, Container, Card, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, TextField } from '@mui/material';
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { ApproveIcon, FileIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { type } from "@testing-library/user-event/dist/type";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import TrashIcon from '../../../images/TrashIcon.png';
import { t } from 'i18next';

function Bidding() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [open, setOpen] = React.useState(false);
    const [openBidNumber, setOpenBidNumber] = React.useState(false);
    const [biddingData, setBiddingData] = useState();
    const [addBiddingInfo, setAddBiddingInfo] = useState();
    const [bidValue, setBidValue] = useState();
    const [cellValue, setCellValue] = useState();
    const [isTermsAndConditionsAccepted, setIsTermsAndConditionsAccepted] = useState(false);
    const [isBiddingDocumentAccepted, setIsBiddingDocumentAccepted] = useState(false);
    const [isRefreshed, setIsRefreshed] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRequestNo, setSelectedRequestNo] = useState(null);
    const [biddingsList, setBiddingsList] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [isAccepted, setIsAccepted] = useState(false);
    const [documentsArr, setDocumentsArr] = useState([]);
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [fileuploadError, setFileuploadError] = useState('');
     const [isApiCalled, setIsApiCalled] = useState(false);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    const [errorMessage, setErrorMessage] = useState({
        bidError: "",
        termsError: "",
        bidDocAcceptError: ""
    });


    const handleClickOpen = (cellValues) => {
        setOpen(true);
        setCellValue({
            allotmentRequestNumber: cellValues?.row?.allotmentRequestNumber,
            stakeholderType: stakeholderDetails?.category,
            stakeholderUrn: stakeholderDetails?.urn,
            baseBidPrice: cellValues?.row?.baseBidPrice,
            biddingTermsFileId: cellValues?.row?.biddingTermsFileId,
        });

    };
    const handleClose = () => {
        setErrorMessage({ ...errorMessage, bidError: "", termsError: "" })
        setIsTermsAndConditionsAccepted(false);
        setBidValue();
        setIsRefreshed(false);
        setOpen(false);
    };

    const onViewDetails = (row) => {
        navigate('./biddingDetails', {
            state: { selectedRow: row, page: "addBid" }
        });
    }

    const columns = [
        // { field: 'allotmentRequestNumber', headerName: 'Request Number', width: 180 },
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
            // renderCell: (params) => {
            //     const endDateTime = moment(
            //         `${params.row.biddingEndDate} ${params.row.biddingEndTime}`,
            //         'YYYY-MM-DD hh:mm A'
            //     );
            //     const now = moment();
            //     const isExpired = now.isAfter(endDateTime);

            //     return isExpired ? (<Link style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline'}} to={params} onClick={() => handleClickOpenBidNumber(params.row)}>{params.value}</Link>)
            //         : (
            //             <span style={{ cursor: 'not-allowed' }}>{params.value}</span>)
            // }
        },
        {
            field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: 'number', width: 150,
            valueGetter: params => params?.value?.toFixed(2),
        },
        { field: 'firstPartyLocationAddress', headerName: 'Origin', width: 250 },
        { field: 'secondPartyLocationAddress', headerName: 'Destination', width: 250 },

        {
            field: 'materialType', headerName: 'Material Type', width: 140, valueFormatter: (params) => {
                if (params.value === 'CB') {
                    return 'Chip Bamboo';
                }
                else if (params.value === 'RB') {
                    return 'Raw Bamboo';
                }
            }
        },

        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'biddingStartTime', headerName: 'Bidding Start Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }
        },
        {
            field: 'biddingEndTime', headerName: 'Bidding End Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }

        },
        {
            field: 'baseBidPrice', headerName: 'Base Rate(per ton per KM)', type: 'number', width: 150,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'lowestBid', headerName: 'Lowest Bid', type: 'number', width: 170,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'decrementValue', headerName: 'Decrement Value', type: 'number', width: 160,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'transporterLastBid', headerName: 'Own Bid', type: 'number', width: 160,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'transporterBidRank', headerName: 'Rank', type: "number", width: 100,
            renderCell: (params) => {
                const endDateTime = moment(
                    `${params.row.biddingEndDate} ${params.row.biddingEndTime}`,
                    'YYYY-MM-DD hh:mm A'
                );
                const now = moment();
                const isExpired = now.isAfter(endDateTime);

                return isExpired ? params?.value : "-"
            }
        },
        {
            field: 'bidDocumentList',
            headerName: 'Documents',
            width: 300,
            renderCell: (params) => {
                const docs = params.value || [];
                if (docs.length === 0) return "No files";
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {docs.map((doc) => (
                            <Link
                                // key={index}
                                onClick={(e) => viewdownloadDocument(doc?.biddingTermsFileId, doc?.biddingTermsFileName, "Download")}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                {doc.biddingTermsFileName}
                            </Link>
                        ))}
                    </div>
                );
            }
        },
        {
            field: "Bid",
            renderCell: (cellValues) => {
                const now = moment();
                const startDateTime = moment(
                    `${cellValues.row.biddingStartDate} ${cellValues.row.biddingStartTime}`,
                    'YYYY-MM-DD hh:mm A'
                );
                const endDateTime = moment(
                    `${cellValues.row.biddingEndDate} ${cellValues.row.biddingEndTime}`,
                    'YYYY-MM-DD hh:mm A'
                );
                const bidDocAccepted = cellValues?.row?.isBidDocumentAccepted === true
                // const bidAcceptDoc = documentsArray?.find((item) => item.documentType === "BidAcceptanceDoc")?.documentBlobName
                const isInRange = now.isSameOrAfter(startDateTime) && now.isSameOrBefore(endDateTime);
                const isButtonEnabled = isRefreshed && isInRange && bidDocAccepted && selectedRequestNo?.id === cellValues.row.id;

                return (
                    <>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={!isButtonEnabled}
                            onClick={() => handleClickOpen(cellValues)}>Bid</Button>
                    </>
                )
            }
        },
        {
            field: "action", headerName: 'Action', width: 150,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title="View Details">
                            <IconButton color="primary" onClick={() => onViewDetails(params?.row)}><ViewIcon /></IconButton>
                        </Tooltip>
                    </>
                )
            }
        },
    ];


    useEffect(() => {
        if (decoded.extension_URN) {
            getStakeDetails();
        }
    }, [decoded.extension_URN]);

    function getStakeDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    useEffect(() => {
        if (stakeholderDetails?.urn) getBiddingDetails();
    }, [stakeholderDetails?.urn]);

    const getBiddingDetails = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_BIDDING_DETAILS,
                {
                    "stakeholderUrn": stakeholderDetails?.urn
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            ).then((response) => {
                setBiddingData(response.data.spotBiddingAllotmentRequestDetailsList);
                const updatedRow = response.data.spotBiddingAllotmentRequestDetailsList?.find((r) => r?.id === selectedRequestNo?.id);
                // setRows(res.data);
                setSelectedRequestNo(updatedRow); // Update selected row
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const onTextValueChange = (e) => {
        const isValid = PIT_VALIDATIONS.validation(e.target.value)
        isValid && setBidValue(parseFloat(e.target.value));
        setErrorMessage({ ...errorMessage, bidError: "" });
    }

    const addBiddingDetails = () => {
        loaderService.showLoader();
        apiClient
            .post(
                ADD_BIDDING_DETAILS,
                {
                    "allotmentRequestNumber": cellValue?.allotmentRequestNumber,
                    "stakeholderType": cellValue?.stakeholderType,
                    "stakeholderUrn": stakeholderDetails?.urn,
                    "baseBidPrice": cellValue?.baseBidPrice,
                    "biddingValue": bidValue,
                    "biddingDate": new Date(),
                    "isBiddingTermAccepted": isTermsAndConditionsAccepted,
                    "biddingTermsFileId": cellValue?.biddingTermsFileId

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            ).then((response) => {
                if (response.data.isSuccess === true) {
                    setAddBiddingInfo(response.data.transporterScheduleDetails);
                    getBiddingDetails();
                    setIsRefreshed(false);
                    toast.success(response.data.message)
                    setOpen(false);
                }
                else {
                    toast.error(response.data.message);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    const onSubmitClick = (e) => {
        const bidvaluelimit = cellValue?.baseBidPrice
        if (bidValue >= bidvaluelimit) {
            setErrorMessage({ ...errorMessage, bidError: `Bidding value schould be less than Base Rate ${bidvaluelimit} ` });
        }
        else if (!bidValue) {
            setErrorMessage({ ...errorMessage, bidError: `Please enter Bid value ` });

        }
        else {
            setErrorMessage({ ...errorMessage, bidError: "", termsError: "" });
            addBiddingDetails();
        }

    }

    const onTermsChange = (e) => {
        if (isTermsAndConditionsAccepted === false) {
            setIsTermsAndConditionsAccepted(true)
        }
        else {
            setIsTermsAndConditionsAccepted(false)
        }
    }

    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": documentBlobName,
                    "containerName": "pit",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName
                    const splittedName = fileName.split('.')
                    const fileExtension = splittedName[splittedName.length - 1];
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                            fileType = 'image/jpeg';
                            break;
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const handleRefresh = () => {
        setIsRefreshed(true);
        getBiddingDetails();
    }

    const handleSelectionModelChange = (newSelection) => {
        setSelectedRows(newSelection);
        const selectedId = newSelection[0];
        const selected = biddingData.find((row) => row.id === selectedId);
        setSelectedRequestNo(selected || null);
    };


    const onAcceptanceDoc = () => {
        const tempArr = [];
        documentsArr.map((item) => {
            tempArr.push({
                "acceptedTermsFileId": item?.blobFileName,
                "acceptedTermsFileName": item?.fileName,
                "containerName": "pit",
            })
        });
        loaderService.showLoader();
        apiClient
            .post(
                ACCEPT_BID_DOCUMENT,
                {
                    "stakeholderUrn": getLocalStorageItem('urn'),
                    "allotmentRequestNumber": selectedRequestNo?.allotmentRequestNumber,
                    "acceptedBidDocumentList": tempArr
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            ).then((response) => {
                if (response.data.isSuccess === true) {
                    toast.success(response.data.message);
                    getBiddingDetails();
                    setDocumentsArr([]);
                }
                else toast.error(response.data.message)
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });

    };

    const handleClickOpenBidNumber = (row) => {
        setOpenBidNumber(true);
        loaderService.showLoader();
        apiClient
            .post(GET_BIDDINGS_LIST_BY_REQ_NUMBER,
                {
                    "allotmentRequestNumber": row.allotmentRequestNumber,
                    "bidNumber": row.bidNumber
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }, null
            ).then((response) => {
                setBiddingsList(response.data.spotBiddingAllotment);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const handleCloseBidNumber = () => {
        setOpenBidNumber(false);
    }

    const columnBids = [
        {
            field: 'bidValueId', headerName: 'Rank', width: 80,
            renderCell: (index) => index.api.getRowIndex(index.row.bidValueId) + 1
        },
        { field: 'transporterName', headerName: 'Transporter Name', width: 400, },

    ];

    // const isAccepted = selectedRequestNo?.isBidDocumentAccepted === true;
    // console.log("isAccepted", isAccepted, selectedRequestNo?.isBidDocumentAccepted)
    useEffect(() => {
        if (selectedRequestNo) {
            setIsAccepted(selectedRequestNo?.isBidDocumentAccepted);
        }
    }, [selectedRequestNo]);

    // const onConfirmSubmit = (e) => {
    //     handleLogModalClose();
    //     onAcceptanceDoc();;
    // }

    
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onAcceptanceDoc();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const onSubmitButtonClick = (e) => {
        handleLogModalOpen();
    }

    const onAccept = (e) => {
        if (isAccepted === false) {
            toast.error("Please Accept Bid Documents Terms & Conditions")
        }
        else if (documentsArr?.length === 0) {
            toast.error("Please Upload accepted Bid Documents Terms & Conditions")
        }
        else onSubmitButtonClick();
    }

    const onDocAcceptanceChange = (e) => {
        if (selectedRequestNo?.isBidDocumentAccepted === false) {
            setIsAccepted(true)
        }

        // else {
        //     setIsBiddingDocumentAccepted(false)
        // }
    }

    useEffect(() => {
        if (selectedFile) {
            getDocumentUploadDetails();
        }
    }, [selectedFile]);

    useEffect(() => {
        if (documentUploadDetails) {
            let tempARR = documentsArr ? [...documentsArr] : []
            documentUploadDetails?.blobResponse && tempARR.push(documentUploadDetails?.blobResponse);
            setDocumentsArr(tempARR);
        }
    }, [documentUploadDetails]);

    const uploadDocument = (e, type) => {
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setFileuploadError('The file should be less than 5MB');
            setSelectedFile();
        }
        else if (e.target.files[0].name.split('.').length > 2) {
            setFileuploadError("Double extension file detected");
            setSelectedFile();
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setFileuploadError(FILE_NAME_VALIDATION_ERROR);
            setSelectedFile();
        }
        else {
            setSelectedFile(e.target.files[0]);
            setFileuploadError('');
        }
    };

    function getDocumentUploadDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "pit");
        apiClient
            .post(
                UPLOAD_DCUMENT,
                formData,
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                setDocumentUploadDetails(response.data);
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const onDeleteFile = (e, item) => {
        e.preventDefault();
        const rows = [...documentsArr];
        const index = rows.findIndex((doc) => doc === item);
        if (index !== -1) {
            rows.splice(index, 1);
            setDocumentsArr(rows);
        }
    };

    return (
        <>
            <Container maxWidth="xxl">
                {/* {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT32</p>} */}
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Add Bid
                    </Typography>
                    <Button variant="contained" color="primary" disabled={!(selectedRequestNo) || selectedRequestNo?.isBidDocumentAccepted === false} onClick={(e) => handleRefresh()} style={{ marginBottom: 10 }}>
                        Refresh
                    </Button>
                </Stack>
                {/* <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <Typography variant="h5" gutterBottom>
                        Add Bid
                    </Typography>
                </Stack> */}
                <Card>
                    <CardContent>
                        <Box sx={{ height: 400, width: '100%' }}>
                            {biddingData &&
                                <DataGrid
                                    getRowHeight={() => 'auto'}
                                    rows={biddingData}
                                    columns={columns}
                                    pageSize={5}
                                    rowsPerPageOptions={[5]}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    checkboxSelection
                                    selectionModel={selectedRows}
                                    onSelectionModelChange={handleSelectionModelChange}
                                    isRowSelectable={(params) => {
                                        const endDateTime = moment(
                                            `${params.row.biddingEndDate} ${params.row.biddingEndTime}`,
                                            'YYYY-MM-DD hh:mm A'
                                        );
                                        const now = moment();
                                        const isExpired = now.isAfter(endDateTime);
                                        return (selectedRows.length === 0 || selectedRows.includes(params.id)) && !(isExpired);
                                    }}
                                />
                            }
                        </Box>


                    </CardContent>

                </Card>
                {
                    selectedRequestNo &&
                    <Grid container spacing={1} mt={1}>
                        <Grid item xs={12} lg={6}>
                            <FormControl required error={errorMessage.bidDocAcceptError} variant="standard" >
                                <FormGroup >
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={isAccepted}
                                                disabled={selectedRequestNo.isBidDocumentAccepted} name="IsBidDocumentAccepted" onChange={(e) => onDocAcceptanceChange(e)} />
                                        }
                                        label={`I accept the Bid Document Terms & Conditions`} />
                                </FormGroup>
                                <FormHelperText>{errorMessage.bidDocAcceptError}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={documentsArr?.length > 1 ? 12 : 6}>
                            <div className='row-flex'>
                                <label className={selectedRequestNo?.isBidDocumentAccepted === true ? "" : "view-file-link-common"}>
                                    <input
                                        style={{ display: "none" }}
                                        type="file"
                                        accept="image/jpeg, image/jpg, image/png, .pdf"
                                        name="photo"
                                        onChange={(e) => uploadDocument(e)}
                                        disabled={selectedRequestNo?.isBidDocumentAccepted}
                                    />Upload Accepted Terms & Conditions Documents
                                </label>
                                {documentsArr?.map((item, index) => {
                                    return (
                                        <div style={{ display: "flex", flexDirection: "row", marginLeft: '1vh' }} className='view-file-name-common'>
                                            {item?.fileName}
                                            <img src={TrashIcon} style={{ cursor: "pointer", marginLeft: "2vh", height: "3vh" }} alt="TrashIcon" onClick={(e) => onDeleteFile(e, item)} />
                                        </div>
                                    )
                                })}
                            </div>
                            <Typography style={{ marginLeft: "3vh" }} variant="subtitle2" fontSize="1.8vh" align="left" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                            <div className='resource-knowledge-error-message' >{fileuploadError}</div>
                        </Grid>
                        <Grid item xs={12} lg={12}>
                            <Button style={{ float: "right" }} variant="contained" disabled={selectedRequestNo?.isBidDocumentAccepted} onClick={(e) => onAccept(e)} startIcon={<ApproveIcon />}>Accept Terms & Conditions</Button>
                        </Grid>
                    </Grid>
                }
            </Container>
            <Dialog
                open={open}
                onClose={handleClose}>
                <DialogTitle >Bid Value</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <Typography variant="subtitle2" mb={1} gutterBottom>Add Bid Value(in INR)</Typography>
                            <TextField fullWidth
                                // required
                                error={errorMessage.bidError}
                                helperText={errorMessage.bidError}
                                label="Bid Value"
                                name="biddingValue"
                                onChange={(e) => onTextValueChange(e)}
                                value={bidValue}
                                type="number"
                                onFocus={handleNumberFieldFocus}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                inputProps={{
                                    maxLength: "15"
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} display='flex' alignItems="center" justifyContent="left">
                            <FormControl required error={errorMessage.termsError} variant="standard" >
                                <FormGroup >
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={isTermsAndConditionsAccepted} name="isBiddingTermAccepted" onChange={(e) => onTermsChange(e)} />
                                        }
                                        label="I accept the Terms and Conditions" />
                                </FormGroup>
                                <FormHelperText>{errorMessage.termsError}</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isTermsAndConditionsAccepted === false} onClick={(e) => onSubmitClick(e)}>Submit</Button>
                    <Button onClick={(e) => handleClose(e)} >Cancel</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} open={openBidNumber} onClose={handleCloseBidNumber}>
                <DialogContent>
                    <Box sx={{ height: 300, width: "100%" }}>
                        {biddingsList &&
                            <DataGrid
                                rows={biddingsList}
                                getRowHeight={() => 'auto'}
                                getRowId={(row) => row.bidValueId}
                                columns={columnBids}
                                rowsPerPageOptions={[5]}
                                pageSize={5} />
                        }
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseBidNumber}>OK</Button>
                </DialogActions>
            </Dialog>
            <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Accept Bid Document Terms & Conditions" />

        </>
    )
}
export default Bidding;